import {
     CLEAR_CONNECTED_MASTER_DETAIL, FETCH_ORDER_CONNECTED_MASTER_DETAIL, FETCH_SHIPMENT_CONNECTED_MASTER_DETAIL,
    FETCH_ADVANCE_NOTICE_SHIPMENT, FETCH_ASN_STATUS_COUNT, FETCH_ASN_DETAIL, FETCH_SHIPMENT_TEMPLATE_HEADER, 
    FETCH_ORDER_CONNECTED_MASTER_ENTRIES, FETCH_SHIPMENT_CONNECTED_MASTER_ENTRIES, FETCH_ASN_ACTION_TAGS,
    FETCH_SUGGESTED_DOCK_LIST,VEHICLE_ENTRY_DATA_LIST,FETCH_ASN_INVOICE_CONFIG,GENERATE_ASN_INVOICE,
    FETCH_SUGGESTED_LOCATION
} from "../types"

const INIT_STATE = {
    shipmentConnectedMasterData: null,
    orderConnectedMasterData: null,
    allASN: [],
    totalRows:0,
    statusCount: null,
    asnDetail: null,
    asnDetailItemsCount: 0,
    shipmentTemplateHeader: [],
    shipmentMasterEntries: [],
    itemMasterEntries: [],
    PO_Number:"",
    asnActionTags: [],
    suggestedDock: [],
    asnInvoiceConfigList:[]
}

export default (state=INIT_STATE, action) => {
    switch(action.type){
        case FETCH_SHIPMENT_CONNECTED_MASTER_DETAIL: return {...state, shipmentConnectedMasterData: action.payload}
        case FETCH_ORDER_CONNECTED_MASTER_DETAIL: return {...state, orderConnectedMasterData: action.payload}
        case FETCH_SHIPMENT_CONNECTED_MASTER_ENTRIES: return {...state, shipmentMasterEntries: action.payload}
        case FETCH_ORDER_CONNECTED_MASTER_ENTRIES: return {...state, itemMasterEntries: action.payload}
        case CLEAR_CONNECTED_MASTER_DETAIL: return {...state, shipmentConnectedMasterData: null, orderConnectedMasterData: null}
        case FETCH_ADVANCE_NOTICE_SHIPMENT: return {
            ...state, 
            allASN: action.payload.rows, totalRows: action.payload.count,
            allLabelOptions:action.payload?.allLabelOptions || []
        }
        case FETCH_ASN_STATUS_COUNT: return {...state, statusCount: action.payload}
        case FETCH_ASN_DETAIL: return {...state, asnDetail: action.payload.data, asnDetailItemsCount: action.payload.count}
        case FETCH_SHIPMENT_TEMPLATE_HEADER: return {...state, shipmentTemplateHeader: action.payload}
        case FETCH_ASN_ACTION_TAGS: return {...state, asnActionTags: action.payload}
        case FETCH_SUGGESTED_DOCK_LIST: return {...state, suggestedDock: action.payload}
        case FETCH_SUGGESTED_LOCATION: return {...state, suggestedLocations: action.payload}
        case VEHICLE_ENTRY_DATA_LIST: return {...state, tripAndCheckpointData: action.payload}
        case FETCH_ASN_INVOICE_CONFIG: return {...state, asnInvoiceConfigList: action.payload}
        default: return state
    }
}